export default "__VITE_ASSET__Cw$r2qIw__"